import { palette, admin } from '../../styles/tokens';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  subtitle?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export function EmptyState({ icon, title, subtitle, actionLabel, onAction }: EmptyStateProps) {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', padding: '48px 24px', textAlign: 'center',
    }}>
      {icon && (
        <div style={{
          width: 48, height: 48, borderRadius: '50%',
          background: palette.g100,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: palette.g400, marginBottom: 16,
        }}>
          {icon}
        </div>
      )}
      <div style={{ fontSize: 16, fontWeight: 600, color: admin.header }}>
        {title}
      </div>
      {subtitle && (
        <div style={{
          fontSize: 13, color: admin.caption, lineHeight: 1.5,
          maxWidth: 320, marginTop: 6,
        }}>
          {subtitle}
        </div>
      )}
      {actionLabel && onAction && (
        <button
          onClick={onAction}
          style={{
            marginTop: 16, padding: '8px 20px', borderRadius: 8,
            background: palette.accent, color: palette.white,
            border: 'none', fontSize: 13, fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}
